import { defineMessages } from 'react-intl-next';

export default defineMessages({
	showMoreButtonText: {
		id: 'paginated-picker.async-select.menu-list.show-more-button.show-more-button-text',
		defaultMessage: 'Show more',
		description: 'Clicking this button will load more items into the dropdown',
	},
});
